import { useStores } from '@littlebird/sdk';
import { useLocation } from '@tanstack/react-router';
import { useRegisterActions } from 'kbar';
import flattenDeep from 'lodash/flattenDeep';

import { uiStore } from '@/stores/ui.store';

import { actionToKBar } from './actions';
import { type Action, type CommandBarContext } from './actions/types';

function getRegistrationKey(
  registerable: { id: string; selected?: boolean }[]
) {
  return registerable.map((r) => (r.selected ? `${r.id}*` : r.id)).join('');
}

export default function useCommandBarActions(
  actions: Action[],
  additionalDeps: React.DependencyList = [],
  contextOverrides: Pick<CommandBarContext, 'threadId'> = {}
) {
  const query = uiStore.commandBarQuery;
  const location = useLocation();
  const stores = useStores();

  // Create the command bar context directly, removing the need for a separate
  // useActionContext hook.
  const context: CommandBarContext = {
    query,
    stores,
    location,
    ...contextOverrides,
  };

  const registerable = flattenDeep(
    actions.map((action) => actionToKBar(action, context))
  );

  // Register the actions again when the action list, a selected state, the
  // location, or the active document or collection changes
  useRegisterActions(registerable, [
    getRegistrationKey(registerable),
    location.pathname,
    contextOverrides.threadId,
    ...additionalDeps,
  ]);
}
